import React from "react";
import "./diagram.css";
import {PieChart, Pie, Sector, Cell, ResponsiveContainer, Label, Rectangle} from 'recharts';
import ChiefDataScientist from "../../Assets/Images/Roles/ChiefDataScientist.svg";
import ChiefInformationOfficer from "../../Assets/Images/Roles/ChiefInformationOfficer.svg";
import ChiefTechnologyOfficer from "../../Assets/Images/Roles/ChiefTechnologyOfficer.svg";
import ChiefInnovationOfficer from "../../Assets/Images/Roles/ChiefInovationOfficer.svg";
import ChiefFinancialOfficer from "../../Assets/Images/Roles/ChiefFinacialOfficer.svg";
import ChiefDataOfficer from "../../Assets/Images/Roles/ChiefDataOfficer.svg";
import DataScientist from "../../Assets/Images/Roles/DataScientist.svg";
import Information from "../../Assets/Images/Roles/Information.svg";
import Technology from "../../Assets/Images/Roles/Technology.svg";
import Innovation from "../../Assets/Images/Roles/Innovation.svg";
import Financial from "../../Assets/Images/Roles/Financial.svg";
import Data from "../../Assets/Images/Roles/Data.svg";
import PropTypes from "prop-types";
import {onLoadImages} from "../CommonMethods";

const COLORS = ['rgba(255,255,255,0.05)', 'rgba(0,196,159,0.16)', 'rgba(255,187,40,0.16)', 'rgba(255,128,66,0.16)'];

const RADIAN = Math.PI / 180;

let width = window.innerWidth;
let textBoxWidth = 200;
let lengthExtender = 10;
let sliceInfoWidth = 140;
let middleTextBoxWidth = textBoxWidth - 75;

if(width > 1200){
    textBoxWidth = 200;
    lengthExtender = 10;
    sliceInfoWidth = 140;
    middleTextBoxWidth = textBoxWidth - 75;
}
else if(width > 950){
    textBoxWidth = 200;
    lengthExtender = 5;
    sliceInfoWidth = 140;
    middleTextBoxWidth = textBoxWidth - 75;
}
else if(width > 750){
    textBoxWidth = 200;
    lengthExtender = 3;
    sliceInfoWidth = 130;
    middleTextBoxWidth = textBoxWidth - 75;
}
else if(width > 600){
    textBoxWidth = 140;
    lengthExtender = 2.2;
    sliceInfoWidth = 130;
    middleTextBoxWidth = textBoxWidth - 75;
}
else if(width > 450){
    textBoxWidth = 110;
    lengthExtender = 1.8;
    sliceInfoWidth = 115;
    middleTextBoxWidth = textBoxWidth - 75;
}
else{
    textBoxWidth = 100;
    lengthExtender = 1;
    sliceInfoWidth = 80;
    middleTextBoxWidth = textBoxWidth - 65;
}


const problemActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    let { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + lengthExtender) * cos;
    const sy = cy + (outerRadius + lengthExtender) * sin;
    const mx = cx + (outerRadius + (3 * lengthExtender)) * cos;
    const my = cy + (outerRadius + (3 * lengthExtender)) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * (5 * lengthExtender );
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
    fill = "rgb(222,22,22)";


    return (
        <g>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill="url(#colorUv)"
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill="url(#colorUv)"
            />
            {
                lengthExtender > 2 &&
                <>
                    <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
                    <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
                </>
            }

            <foreignObject
                           width={
                payload.name === "Chief Information Officer" || payload.name === "Chief Financial Officer"? middleTextBoxWidth+"px":textBoxWidth+"px"
                           } height={"200px"}
                           x={textAnchor === "start"? ex + (cos >= 0 ? 1 : -1) * 10 : ex + (cos >= 0 ? 1 : -1) * 10 - ( payload.name === "Chief Information Officer" || payload.name === "Chief Financial Officer"? middleTextBoxWidth : textBoxWidth)}
                           y={ey - 25}
                           dy={18}>
                <div className={textAnchor === "start"? "diagram-role-name":"diagram-role-name right-align-text"}>
                    {payload.name}
                </div>
                <div className={textAnchor === "start"? "problem-description":"problem-description right-align-text"}>
                    {payload.problemDescription}
                </div>
            </foreignObject>

            <defs>

                <linearGradient id="colorUv" x1="2" y1="1" x2="0" y2="0">
                    <stop offset="30%" stopColor="#270101" stopOpacity={0.5} />
                    <stop offset="95%" stopColor="#DE1616" stopOpacity={0.3} />
                </linearGradient>
            </defs>
        </g>
    );
};
const problemLabel = ({cx, cy, midAngle, innerRadius, outerRadius, payload, percent, index, onClick}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <foreignObject width={sliceInfoWidth} height={"100px"} x={x - (sliceInfoWidth > 80? 60:35)} y={y - 50}>
            <div className="slice-container" onClick={()=>{onClick(index)}}>
                <div className="slice-title">
                    {payload.name}
                </div>
                <div className="slice-img">
                    <img src={payload.problemImage} width={"100%"} height={"100%"} alt={payload.name}/>
                </div>
                <div className="slice-info problem">
                    {payload.problemName}
                </div>
            </div>
        </foreignObject>

    );
};


const solutionActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    let { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + lengthExtender) * cos;
    const sy = cy + (outerRadius + lengthExtender) * sin;
    const mx = cx + (outerRadius + (3 * lengthExtender)) * cos;
    const my = cy + (outerRadius + (3 * lengthExtender)) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * (5 * lengthExtender );
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
    fill = "rgb(0,233,193)";


    return (
        <g>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill="url(#solutionActiveColor)"
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill="url(#solutionActiveColor)"
            />
            {
                lengthExtender > 2 &&
                <>
                    <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
                    <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
                </>
            }

            <foreignObject
                width={
                    payload.name === "Chief Information Officer" || payload.name === "Chief Financial Officer"? middleTextBoxWidth+"px":textBoxWidth+"px"
                } height={"200px"}
                x={textAnchor === "start"? ex + (cos >= 0 ? 1 : -1) * 10 : ex + (cos >= 0 ? 1 : -1) * 10 - ( payload.name === "Chief Information Officer" || payload.name === "Chief Financial Officer"? middleTextBoxWidth : textBoxWidth)}
                y={ey - 25}
                dy={18}>
                <div className={textAnchor === "start"? "diagram-role-name":"diagram-role-name right-align-text"}>
                    {payload.name}
                </div>
                <div className={textAnchor === "start"? "solution-description":"solution-description right-align-text"}>
                    {payload.solutionDescription}
                </div>
            </foreignObject>

            <defs>
                <linearGradient id="solutionActiveColor" x1="2" y1="1" x2="0" y2="0">
                    <stop offset="30%" stopColor="#00E9C1" stopOpacity={0.5} />
                    <stop offset="95%" stopColor="#0A6A5A" stopOpacity={0.3} />
                </linearGradient>
            </defs>
        </g>
    );
};
const solutionLabel = ({cx, cy, midAngle, innerRadius, outerRadius, payload, percent, index, onClick}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);



    return (
        <foreignObject width={sliceInfoWidth} height={"100px"} x={x - (sliceInfoWidth > 80? 60:35)} y={y - 50}>
            <div className="slice-container" onClick={()=>{onClick(index)}}>
                <div className="slice-title">
                    {payload.name}
                </div>
                <div className="slice-img">
                    <img src={payload.solutionImage} width={"100%"} height={"100%"} alt={payload.name}/>
                </div>
                <div className="slice-info solution">
                    {payload.solutionName}
                </div>
            </div>
        </foreignObject>

    );
};

export default class NavigatingGPTCrossRoad extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [

                {
                    name: 'Chief Data Scientist',
                    value: 100,
                    problemName: "Evolving Frameworks",
                    problemImage: ChiefDataScientist,
                    problemDescription: "Which LLM to use and Why?",
                    solutionDescription: "AnyGen's Unified Interface abstracts the LLMs and Data Scientists have flexibility to use any LLMs",
                    solutionName: "Unified Interface",
                    solutionImage: DataScientist,
                    onClick: this.onPieEnter.bind(this,0)
                },
                {
                    name: 'Chief Information Officer',
                    value: 100,
                    problemName: "Lifecycle Management",
                    problemImage: ChiefInformationOfficer,
                    problemDescription: "How do I manage lifecycle of GenAI projects?",
                    solutionName: "Integrated Lifecycle Management",
                    solutionImage: Information,
                    solutionDescription: "AnyGen's Unified Interface provides Single Pane to Manage GenAI LifeCycle",
                    onClick: this.onPieEnter.bind(this,1)
                },
                {
                    name: 'Chief Technology Officer',
                    value: 100,
                    problemName: "Complexity",
                    problemImage: ChiefTechnologyOfficer,
                    problemDescription: "Too many LLMs, Products around LLMs and Very Complex",
                    solutionName: "No Code/ Low Code",
                    solutionImage: Technology,
                    solutionDescription: "AnyGen's no code / low code platform takes away the complexity of GenAI and enables dev teams to develop at the speed of business",
                    onClick: this.onPieEnter.bind(this,2)
                },
                {
                    name: 'Chief Innovation Officer',
                    value: 100,
                    problemName: "Time to Innovate",
                    problemImage: ChiefInnovationOfficer,
                    problemDescription:"Takes too long to Innovate due to Complexity, disparate Products, LLMs and no uniform life cycle management",
                    solutionName: "Innovate in Minutes",
                    solutionImage: Innovation,
                    solutionDescription:"Innovate at the Speed of Business",
                    onClick: this.onPieEnter.bind(this,3)
                },
                {
                    name: 'Chief Financial Officer',
                    value: 100,
                    problemName: "Cost",
                    problemImage: ChiefFinancialOfficer,
                    problemDescription:"Costs too much making it cost prohibitive",
                    solutionName: "10x ROE",
                    solutionImage: Financial,
                    solutionDescription: "Less Cost, More ROI",
                    onClick: this.onPieEnter.bind(this,4)
                },
                {
                    name: 'Chief Data Officer',
                    value: 100,
                    problemName: "Confidentiality",
                    problemImage: ChiefDataOfficer,
                    problemDescription: "How to ensure confidentiality of the enterprise data in the world of LLMs?",
                    solutionName: "Private LLMs",
                    solutionImage: Data,
                    solutionDescription: "Private LLMs ensure data confidentiality",
                    onClick: this.onPieEnter.bind(this,5)
                },
            ],
            activeIndex: 0,

        }
    }

    onPieEnter = (_, index) => {
        this.setState({
            activeIndex: index,
        });
    };







    render() {
        let {data} = this.state;
        let {type} = this.props;
        let width = window.innerWidth;

        let outerRadius = 270;
        let innerRadius = 104;

        if(width > 1200){
            outerRadius = 270;
            innerRadius = 104;
        }
        else if(width > 950 && width <= 1200){
            outerRadius = 240;
            innerRadius = 94;
        }
        else if(width > 750 && width <= 950){
            outerRadius = 210;
            innerRadius = 80;
        }
        else if(width > 600 && width <= 750){
            outerRadius = 200;
            innerRadius = 77;
        }
        else if(width > 450 && width <= 600){
            outerRadius = 150;
            innerRadius = 59;
        }
        else {
            outerRadius = 120;
            innerRadius = 47;
        }


        return (
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={type === "problem"?problemLabel:solutionLabel}
                        activeIndex={this.state.activeIndex}
                        activeShape={type === "problem"?problemActiveShape:solutionActiveShape}
                        // outerRadius={300}
                        // innerRadius={117}
                        outerRadius={outerRadius}
                        innerRadius={innerRadius}
                        fill="#8884d8"
                        startAngle={360 + 90}
                        endAngle={90}
                        dataKey="value"
                        onMouseEnter={this.onPieEnter}
                        onClick={this.onPieEnter}
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={"rgba(255,255,255,0.00)"} stroke={"white"}
                                  strokeWidth={"0.1px"} strokeOpacity={0.4} style={{outline: 'none'}}/>
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        );
    }
}


NavigatingGPTCrossRoad.defaultProps = {
    type: "problem",
}

NavigatingGPTCrossRoad.propTypes = {
    type: PropTypes.oneOf(["problem","solution"]).isRequired
}

